import { DocumentEditorPage } from '@jarvis/platform-ui';

export function DocumentPreviewPage() {
  return (
    <DocumentEditorPage
      mode="preview"
      filesLinkTo="/finance/secure-pharm-reports"
      filesLinkLabel="Secure Pharm Reports"
    />
  );
}
